import React, { Component } from 'react'
import styled from 'styled-components'
import { Container, Row, Col } from 'styled-bootstrap-grid'

import FadeEntry from 'ui/components/generic/FadeEntry'
import { BodyText as Text } from 'ui/styles/utils'
import Links from 'ui/components/generic/Links'

const Wrapper = styled.div`
  padding: 100px 0;
  background-color: #fff;
`

const Content = styled.div``

class BodyText extends Component {
  render() {
    const { columns } = this.props

    return (
      <Wrapper>
        <Container fluid>
          <Row>
            {columns.map((column, index) => (
              <Col
                key={index}
                sm={12 / columns.length}
                md={8 / columns.length}
                mdOffset={index === 0 ? 2 : 0}
                lg={6 / columns.length}
                lgOffset={index === 0 ? 3 : 0}
              >
                <FadeEntry delay={500 * index}>
                  <Content>
                    <Text dangerouslySetInnerHTML={{ __html: column.body }} />
                    <Links color="primary" links={column.buttons} />
                  </Content>
                </FadeEntry>
              </Col>
            ))}
          </Row>
        </Container>
      </Wrapper>
    )
  }
}

export default BodyText



// WEBPACK FOOTER //
// ./src/ui/components/modules/BodyText/index.js